import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import { helpTopicsContent } from './help-topics.content'
import classes from './help-topics.module.scss'
import Bubble from '../../static/images/bubble.svg'
import { HideOnMobile, HideTabletUpwards } from '../shared'

export const HelpTopics: FC = () => (
  <div className={classes.wrapper}>
    <div>
      <Typography
        component="h2"
        variant="Kollektif/Large"
        className={classes.heading}
        dataTestId="help-topics-title"
      >
        <span>{helpTopicsContent.title}</span>
        <HideTabletUpwards>
          <img
            className={classes.img}
            src={Bubble}
            alt=""
            data-testid="help-topics-image-mobile"
            loading="lazy"
            decoding="async"
          />
        </HideTabletUpwards>
      </Typography>
      <ul className={classes.topicList}>
        {helpTopicsContent.topics.map((topic, index) => (
          <li key={index} data-testid="all-topics">
            <a
              className={classes.topicLink}
              data-item-category={TRACKING_CATEGORIES.NAVIGATION}
              data-item-name={topic.data_item_name}
              data-testid={`${topic.data_item_name}-topic`}
              href={topic.url}
            >
              {topic.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
    <HideOnMobile>
      <img
        className={classes.img}
        src={Bubble}
        alt=""
        data-testid="help-topics-image-desktop"
      />
    </HideOnMobile>
  </div>
)

export default HelpTopics
